import { render, staticRenderFns } from "./BaseChart.vue?vue&type=template&id=2eec6353&scoped=true&"
import script from "./BaseChart.vue?vue&type=script&lang=ts&"
export * from "./BaseChart.vue?vue&type=script&lang=ts&"
import style0 from "./BaseChart.vue?vue&type=style&index=0&id=2eec6353&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec6353",
  null
  
)

export default component.exports